module.exports = __webpack_public_path__ + "media/images/front/doctorbook_logo-4fcc8f2d4ca4496fc394106c979b8478.png";